export const SCREEN_LINK_PREFIX = '#';
export const PREVIOUS_SLIDE = `${SCREEN_LINK_PREFIX}previousSlide`;
export const NEXT_SLIDE = `${SCREEN_LINK_PREFIX}nextSlide`;
export const LAST_VISITED_SLIDE = `${SCREEN_LINK_PREFIX}lastVisitedSlide`;
